import React, { useState, useEffect } from 'react';

import Spinner from '../../components/Spinner';

const UserProfile = () => {
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    const fetchUserInfo = async () => {
      const userInfoResponse = await fetch(
        `${drupalSettings.base_url}/getUserInfo`
      );
      if (userInfoResponse.ok) {
        const userData = await userInfoResponse.json();
        setUserInfo(userData[0]);
      }
    };

    fetchUserInfo();
  }, []);

  let profile = null;
  if (userInfo) {
    const userInfoFields = [
      {
        label: Drupal.t('First name'),
        value: userInfo.field_first_name,
      },
      {
        label: Drupal.t('Last name'),
        value: userInfo.field_last_name,
      },
      {
        label: Drupal.t('Email'),
        value: userInfo.mail,
      },
      {
        label: Drupal.t('Phone number'),
        value: userInfo.field_phone_number,
      },
      {
        label: Drupal.t('Street address'),
        value: userInfo.field_street_address,
        className: 'street-address',
      },
      {
        label: Drupal.t('Postal code'),
        value: userInfo.field_postal_code,
      },
      {
        label: Drupal.t('City', {}, { context: 'Address label' }),
        value: userInfo.field_city,
      },
    ];

    profile = userInfoFields.map((field) => {
      return (
        <div
          key={field.label}
          className={`user-info__field user-info__field-${field.className}`}
        >
          <strong>{field.label}</strong>
          <p>{field.value}</p>
        </div>
      );
    });
  }

  return (
    <div className="user-info">
      {profile ?? (
        <div style={{ width: '100%' }}>
          <Spinner />
        </div>
      )}
    </div>
  );
};

export default UserProfile;
